import Tabs from './components/tabs'

$(document).ready(function () {
  if($('.association').length > 0) {
    new Tabs();
   
    var currentItem
    var currentPanel
    document.getElementById("cartemonde").querySelectorAll('.worldmap .continent').forEach(item => {
      // Hover
      item.addEventListener('mouseover', (e) => {
        e.preventDefault()
        let id = item.id
        const panel = document.getElementById("targets").querySelector("#_panel-"+id)
        if (panel != null){
          item.classList.add('active')
        }
      })
      item.addEventListener('mouseout', (e) => {
        e.preventDefault()
        let id = item.id
        const panel = document.getElementById("targets").querySelector("#_panel-"+id)
        if (panel != null){
          item.classList.remove('active')
        }
      })
      // Click
      item.addEventListener('click', (e) => {
        e.preventDefault()
        let id = item.id
        const panel = document.getElementById("targets").querySelector("#_panel-"+id)
        const tab = document.getElementById("targets").querySelector("#_tab-"+id)
        if (panel != null){
          const panels = document.getElementById("targets").querySelectorAll(".tabs__panel")
          panels.forEach(pan => {
            hidePanel(pan)
          })
          const tabs = document.getElementById("targets").querySelectorAll(".tabs__item")
          tabs.forEach(tb => {
            desactiveItem(tb)
          })
          scrolltoId("_tab-"+id)
          if (panel.classList.contains('is-active')) {
            
          } else {
            activeItem(tab)
            showPanel(panel)
          }
        }
      })
    })
    function activeItem (item) {
      item.classList.add('is-active')
      item.setAttribute('aria-selected', true)
      currentItem = item
    }
    function desactiveItem (item) {
      if (item) {
        item.classList.remove('is-active')
        item.setAttribute('aria-selected', false)
      }
    }
    function hidePanel (panel) {
      if (panel) {
        panel.classList.remove('is-visible')
        panel.setAttribute('aria-hidden', true)
      }
    }
    function showPanel (panel) {
      if (panel) {
        panel.classList.add('is-visible')
        panel.setAttribute('aria-hidden', false)
        currentPanel = panel
      }
    }
    function scrolltoId(id){
      var access = document.getElementById(id);
      access.scrollIntoView({behavior: 'smooth'}, true);
    }
  }
});